exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea-value[data-v-3645ed3c]{line-height:16px}.td-id[data-v-3645ed3c]{width:3%;max-width:40px;min-width:40px;text-align:center}.td-name[data-v-3645ed3c]{width:250px}.td-sum[data-v-3645ed3c]{width:10%;min-width:150px}.td-actions[data-v-3645ed3c]{width:6%;min-width:90px;max-width:90px;text-align:center!important;vertical-align:top}.text-value-td-div[data-v-3645ed3c]{padding-top:8px}", ""]);

// exports
